/*
  General DOM functions
  Use these functions to select, handle html elements (similar to jQuery)
*/
export const mapDOMElements = (fn) => (items) => [...items].forEach(fn)

export const selectAll = (query, item = document) => item.querySelectorAll(query)

export const selectArr = (query, item = document) => [].slice.call(item.querySelectorAll(query))

export const select = (item = document, query) => item.querySelector(query)

export const selectDoc = (query, item = document) => item.querySelector(query)

export const value = (query, item = document) => item.querySelector(query).value

export const getElems = (query, item = document) => [...item.querySelectorAll(query)]

export const dataValue = ({dataset}) => (id) => dataset[id]

export const removeAttribute = (tag) => (item) => item.removeAttribute(tag)

export const closest = (item) => (query) => item.closest(query)

export const remove = (item) => item.parentNode.removeChild(item)

export const nextSibling = (item) => item.nextElementSibling

export const prevSibling = (item) => item.previousElementSibling

export const toggleAttr = (item, attr) => item.toggleAttribute(attr)

export const setAttr = (attr, value) => (item) => item.setAttribute(attr, value)

export const getAttr = (attr) => (item) => item.getAttribute(attr)

export const submit = (item) => item.submit(item)

export const toggleClass = (item, cls) => item.classList.toggle(cls)

export const setText = (item) => (text) => item.innerText = text

export const setHtml = (item) => (html) => item.innerHTML = html

export const opacity = (value) => (item) => item.style.opacity = `${value}`

export const styles = (elem, styles) => elem.setAttribute("style", Object.entries(styles).map(([key, value]) => `${key}: ${value};`).join(' '))

export const hasClass = (target, className) => new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);

export const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js

export const removeClassAll = (list, cls) => list.map(l => l.classList.remove(cls))

export const addClassAll = (list, cls) => list.map(l => l.classList.add(cls))

export const addClass = (e, cls) => !hasClass(e, cls) ? e.classList.add(cls): false;

export const removeClass = (e, cls) => hasClass(e, cls) ? e.classList.remove(cls): false;

export const toggleClassAll = (items, cls) => [].slice.call(items).map(item => item.classList.toggle(cls))

export const event = (elem, event, func) => elem ? elem.addEventListener(event, func) : console.log('Invalid element to apply ' + event + ': ' + func);